import { 
    MERKZETTEL_NOTOFICATION_AFTER_RELOAD_KEY, 
    SHOW_ADD_PRODUCT_HINWEIS_KEY, 
    SHOW_CREATE_LIST_HINWEIS_KEY, 
    SHOW_DELETE_LIST_HINWEIS_KEY,
    SHOW_RENAME_LIST_HINWEIS_KEY
} from "./localStorageHinweise.js";
import { showHinweis } from "./showHinweis.js";

window.addEventListener("DOMContentLoaded", showNotificationAfterReload);

function showNotificationAfterReload() {
    const key = localStorage.getItem(MERKZETTEL_NOTOFICATION_AFTER_RELOAD_KEY);
    let messageid = null;
    switch (key) {
        case SHOW_ADD_PRODUCT_HINWEIS_KEY:
            messageid = "success-add-product";
            break;
        case SHOW_CREATE_LIST_HINWEIS_KEY:
            messageid = "success-create-list";
            break;
        case SHOW_DELETE_LIST_HINWEIS_KEY:
            messageid = "success-delete-list";
            break;
        case SHOW_RENAME_LIST_HINWEIS_KEY:
            messageid = "success-rename-list";
            break;
    }
    if (messageid) {
        showHinweis(messageid, document.body, "MerkzettelHinweis - showNotificationAfterReload");
    }
    localStorage.removeItem(MERKZETTEL_NOTOFICATION_AFTER_RELOAD_KEY);
}
